import { useQuery } from '@tanstack/react-query'

import { fetchMe } from '@/api/me'

export const ME_QUERY_KEY = ['me'] as const

/** The signed-in person and their orgs. Errors with UNAUTHENTICATED when signed out. */
export const useMe = () => useQuery({ queryKey: ME_QUERY_KEY, queryFn: fetchMe, retry: false, staleTime: 30_000 })
